module.exports = __webpack_public_path__ + "img/orangeCancelled.d7eb239a.svg";